<template lang="pug">
div(v-if="wallId" ref="wall")
  .social-media-wall(:data-cfg-wallid="wallId")

</template>

<script>
export default {
  props: ['extra', 'isPage', 'menu'],
  data() {
    return {
      show: false
    }
  },
  watch: {
    wallId: {
      immediate: true,
      handler() {
        this.$nextTick(() => {
          if (this.$refs.wall) {
            const script = document.createElement("script")
            script.async = true
            script.src = 'https://static.socialmediawall.io/w/init-wall.js'
            this.$refs.wall.insertBefore(script, null)
          }
        })
      }
    }
  },
  computed: {
    wallId() {
      return this.extra && this.extra.options && this.extra.options.count
    }
  },
  methods: {
  }
}
</script>
